import { Button as CurtinUIButton } from '@curtin-dxp/curtin-ui';
import { ButtonProps } from '@curtin-dxp/curtin-ui/dist/components/button/button';

export const Button = (props: ButtonProps) => {
  return <CurtinUIButton {...props}>{props.children}</CurtinUIButton>;
};
